import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

export function getCartToken() {
  let token = localStorage.getItem('cart_token');
  if (!token) {
    token = 'cart-' + Math.random().toString(36).slice(2) + Date.now();
    localStorage.setItem('cart_token', token);
  }
  return token;
}

/* Customer account (separate from the admin token and the cart token) */
export function getCustomerToken() {
  return localStorage.getItem('customer_token');
}

export function getCustomer() {
  const raw = localStorage.getItem('customer');
  return raw ? JSON.parse(raw) : null;
}

export function setCustomerSession(token, customer) {
  localStorage.setItem('customer_token', token);
  localStorage.setItem('customer', JSON.stringify(customer));
}

export function clearCustomerSession() {
  localStorage.removeItem('customer_token');
  localStorage.removeItem('customer');
}

const client = axios.create({ baseURL: API_BASE });

function authHeader() {
  const token = getCustomerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default {
  getProducts: () => client.get('/products').then(r => r.data),
  getProduct: (id) => client.get(`/products/${id}`).then(r => r.data),
  getTestimonials: (productId) => client.get(`/products/${productId}/testimonials`).then(r => r.data),

  getCart: () => client.get(`/cart/${getCartToken()}`).then(r => r.data),
  getAllTestimonials: () => client.get('/testimonials').then(r => r.data),
  addToCart: (productId, licenseType, quantity = 1) =>
    client.post(`/cart/${getCartToken()}/items`, { productId, licenseType, quantity }).then(r => r.data),
  updateCartItem: (itemId, quantity) =>
    client.patch(`/cart/${getCartToken()}/items/${itemId}`, { quantity }).then(r => r.data),
  removeCartItem: (itemId) =>
    client.delete(`/cart/${getCartToken()}/items/${itemId}`),

  checkout: (email, provider) =>
    client.post('/orders/checkout', { cartToken: getCartToken(), email, provider }, { headers: authHeader() }).then(r => r.data),
  getOrderStatus: (reference) => client.get(`/orders/${reference}`).then(r => r.data),

  /* Customer account */
  signup: (fullName, email, password, phone) =>
    client.post('/auth/signup', { fullName, email, password, phone }).then(r => r.data),
  login: (email, password) =>
    client.post('/auth/login', { email, password }).then(r => r.data),
  getMyOrders: () => client.get('/orders/mine', { headers: authHeader() }).then(r => r.data)
};
